import { Task } from "@/api";

import { myTasksFilterData } from "../config/myTasksFilterData";
import useFilterSort from "./useFilterSort";

export function useMyTasksFilterSort() {
  return useFilterSort<Task>(myTasksFilterData);
}
